export default __webpack_public_path__ + "static/media/Snd_CI.c0da9377.mp3";